var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNihMarkGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 50.4 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#637581}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.6 0H3.1C1.5 0 .2 1.3.2 2.9V29c0 1.7 1.3 3 2.9 3h31.6l8.5-16-8.6-16zM16.3 23.2h-2.6L7.4 12.7h-.1v10.5H5V8.9h2.6l6.3 10.5V8.9h2.3v14.3h.1zm4.8 0h-2.4V8.9h2.4v14.3zm11.1 0v-6.5h-6.3v6.5h-2.4V8.9h2.4v5.7h6.3V8.9h2.4v14.3h-2.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.4 16l-8.6 16h2.1c1.2 0 2.6-.9 3.2-1.9L49.6 16 42.1 1.9C41.5.8 40.1 0 38.9 0h-2.1l8.6 16"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNihMarkGray);
export default __webpack_public_path__ + "static/media/logo-nih-mark-gray.74de55338e42db15df463c68f051090d.svg";
export { ForwardRef as ReactComponent };